module.exports = __webpack_public_path__ + "img/mewps.fcfabc1.png";